<template>
    <div class="lang">
        <span style="color:red;margin-left: -12px;">*</span>
        <van-image
                class="stock-img"
                @click="chooseImg"
                :width="imgSize"
                :height="imgSize"
                :src="src">
            <template v-slot:error><van-icon name="photograph" :size="imgSize/2.5" /></template>
        </van-image>
		<van-overlay :show="loading">
		  <div class="loading-div">
		    <van-loading color="#1989fa" />
		  </div>
		</van-overlay>
    </div>
</template>
<script>
import { Image, Icon, Toast, Overlay, Loading } from 'vant';
export default {
    name:"ChoooseImg",
    components:{
        [Image.name]: Image,
        [Icon.name]: Icon,
        [Overlay.name]: Overlay,
        [Loading.name]: Loading
    },
    props: {
        sourceType: {
            type: Number,
            default: 0
        },
        size: {
            type: String,
            default: '80'
        }
    },
    data(){
        return{
            imgSize: '0',
            localId: '',
            src: '',
            loading: false
        }
    },
    methods:{
		refresh() {
			this.localId = '',
			this.src = '',
			this.loading = false
		},
        chooseImg() {
            this.$wx.chooseImage({
                count: 1, // 默认9
                sizeType: ["original"], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album',"camera"], // 可以指定来源是相册还是相机，默认二者都有
                defaultCameraMode: "normal", 
                success: (res) => {
                    console.log(res)
                    this.localId = res.localIds[0]; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    //alert('获取图片id成功：'+ this.localId);
                    this.showImage();
                },
                fail: function () {
                    Toast('选择图片失败');
                }
            });
        },

        showImage() {
            let userAgent = navigator.userAgent.toLowerCase();
            console.log('userAgent', userAgent)
            // iphone 多做一步操作
            if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1){
                this.$wx.getLocalImgData({
                    localId: this.localId, // 图片的localID
                    success: (res) => {
                        //alert('show image'+res);
                        this.src = res.localData;
                        // 上传图片
                        this.upload();
                    },
                    fail: function () {
                        Toast('转换图片失败');
                    }
                });
            }
            // 安卓手机直接显示预览图
            else {
                this.src = this.localId;
                //alert('show image AN'+this.src);
                // 上传图片
                this.upload();
            }

        },
        upload() {
			this.loading = true
            this.$wx.uploadImage({
                localId: this.localId, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 0, // 默认为1，显示进度提示
                success: (res) => {
                    // 返回图片的服务器端ID
					this.loading = false
                    //alert('我要回传照片'+res)
                    this.$emit('finish', res.serverId);
                },
                fail: (res) => {
					this.loading = false
                    console.log('upload fail', res)
                    Toast('图片上传微信服务器失败');
                }
            });
        }
    },
    created() {
        this.imgSize = this.size;
    }
}
</script>
<style lang="less" scoped>
  .loading-div {
    text-align: center;
    margin-top: 45vh;
  }
</style>
